/**
 * Level registry — imports every BUILT level JSON, validates it via `parseLevel`
 * once at module load, and exposes lookups keyed by level id. Mirrors
 * `registry.ts` (units/enemies): adding a stage is "drop a JSON + add a line".
 *
 * This is the single place scenes read level content from, so the world map can
 * launch any built stage by id (`scene.start('battle', { levelId })`) instead of
 * a hardcoded import. Stages listed in `worldmap.json` whose `levelId` is null
 * (or absent here) are sealed/unbuilt and not playable yet.
 */
import { parseLevel, type Level } from './schema/level';

import stage01Olympus from './levels/stage_01_olympus.json';
import stage02Olympus from './levels/stage_02_olympus.json';
import stage03Olympus from './levels/stage_03_olympus.json';

/** Raw level JSONs in pilgrimage order. Append a new stage's import here. */
const RAW_LEVELS: unknown[] = [stage01Olympus, stage02Olympus, stage03Olympus];

export const LEVELS: Map<string, Level> = new Map(
  RAW_LEVELS.map((raw) => {
    const lvl = parseLevel(raw);
    return [lvl.id, lvl] as const;
  }),
);

/** Look up a built level by id, or undefined if it isn't built yet. */
export function getLevel(id: string): Level | undefined {
  return LEVELS.get(id);
}
